var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeadphones(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 48C37.2548 48 48 37.2548 48 24C48 10.7452 37.2548 0 24 0C10.7452 0 0 10.7452 0 24C0 37.2548 10.7452 48 24 48Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 47C36.7025 47 47 36.7025 47 24C47 11.2975 36.7025 1 24 1C11.2975 1 1 11.2975 1 24C1 36.7025 11.2975 47 24 47Z",
    stroke: "#005EFD",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0676 30.1002C13.5902 30.1002 13.1324 29.9106 12.7948 29.573C12.4572 29.2354 12.2676 28.7776 12.2676 28.3002V21.0832C12.2676 20.6058 12.4572 20.148 12.7948 19.8104C13.1324 19.4729 13.5902 19.2832 14.0676 19.2832C14.545 19.2832 15.0028 19.4729 15.3403 19.8104C15.6779 20.148 15.8676 20.6058 15.8676 21.0832V28.2942C15.8683 28.5311 15.8224 28.7658 15.7323 28.9849C15.6422 29.2039 15.5098 29.4031 15.3425 29.5709C15.1753 29.7386 14.9766 29.8718 14.7578 29.9626C14.539 30.0534 14.3045 30.1002 14.0676 30.1002Z",
    fill: "#D3D3D3",
    stroke: "#02022C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2644 27.6371C11.5855 27.4988 10.9753 27.1301 10.537 26.5935C10.0987 26.0569 9.85938 25.3854 9.85938 24.6926C9.85938 23.9997 10.0987 23.3282 10.537 22.7916C10.9753 22.255 11.5855 21.8864 12.2644 21.748",
    stroke: "#02022C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2981 19.2832C33.7755 19.2832 34.2332 19.4729 34.5708 19.8104C34.9084 20.148 35.098 20.6058 35.098 21.0832V28.2942C35.098 28.7716 34.9084 29.2295 34.5708 29.567C34.2332 29.9046 33.7755 30.0942 33.2981 30.0942C32.8207 30.0942 32.3628 29.9046 32.0253 29.567C31.6877 29.2295 31.498 28.7716 31.498 28.2942V21.0832C31.498 20.6058 31.6877 20.148 32.0253 19.8104C32.3628 19.4729 32.8207 19.2832 33.2981 19.2832Z",
    fill: "#D3D3D3",
    stroke: "#02022C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1033 21.748C35.7821 21.8864 36.3924 22.255 36.8307 22.7916C37.269 23.3282 37.5083 23.9997 37.5083 24.6926C37.5083 25.3854 37.269 26.0569 36.8307 26.5935C36.3924 27.1301 35.7821 27.4988 35.1033 27.6371",
    stroke: "#02022C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2855 37.3082H20.6785C20.3602 37.3082 20.055 37.1818 19.83 36.9567C19.6049 36.7317 19.4785 36.4265 19.4785 36.1082V36.1082C19.4785 35.79 19.6049 35.4847 19.83 35.2597C20.055 35.0347 20.3602 34.9082 20.6785 34.9082H24.2836C24.6018 34.9082 24.907 35.0347 25.1321 35.2597C25.3571 35.4847 25.4835 35.79 25.4835 36.1082V36.1082C25.4835 36.4261 25.3573 36.7311 25.1327 36.9561C24.9081 37.181 24.6034 37.3077 24.2855 37.3082V37.3082Z",
    stroke: "#02022C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9032 30.0996C33.9032 34.9066 31.5032 36.1086 25.4902 36.1086",
    stroke: "#02022C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6719 19.2839V18.684C14.6719 16.2933 15.6216 14.0005 17.312 12.3101C19.0025 10.6196 21.2953 9.66992 23.6859 9.66992C26.0766 9.66992 28.3692 10.6196 30.0597 12.3101C31.7501 14.0005 32.6998 16.2933 32.6998 18.684V19.2839",
    stroke: "#02022C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeadphones);
export default __webpack_public_path__ + "static/media/headphones.cace3842937bfe666eaa0dd27d00b71c.svg";
export { ForwardRef as ReactComponent };